import Menu   from "../Menu.js";
import global from "../global.js";

const log = global.log.getLogger("f_mtac.ui.GridSettingsArea");
log.setLevel(log.levels.WARN);

const GridSettingsArea = function() {
    /*
    this.enable_grid_actions = function(enable){
        if (enable === false){
            $(".btn_grid").attr("disabled",true);
        } else {
            $(".btn_grid").removeAttr("disabled");
        }
    };
    */
};

global.app.bootstrap.register_module({
    name: "ui_grid_settings_area_tools",
    deps: ["dom_loaded", "scene", "tools", "default_configuration"],
    init: async () => {
        log.debug("ui_grid_settings_area_tools: init");
        var colors = global.default_configuration.grid.grid.colors;
        var color_by_value = Object.fromEntries(colors.map(color => [color.value, color]));

        var select_color = () => {
            var color_value = global.scene.map.grid.configuration.get("grid.color");
            if (color_value in color_by_value) {
                let color = color_by_value[color_value];
                global.tools.group_select("grid_color_update", `grid_${color.name}`);
            }
        };

        var unselect_color = () => {
            var color_value = global.scene.map.grid.configuration.get("grid.color");
            if (color_value in color_by_value) {
                let color = color_by_value[color_value];
                global.tools.group_unselect("grid_color_update", `grid_${color.name}`);
            }
        };

        Menu.create({
            name: "grid_settings_area", 
            icon: "grid", 
            contents: ["#grid_settings"],
            open_handler: () => {
                log.debug("grid_settings_area: open_handler");
                var grid_configuration = global.scene.map.grid.configuration;
                global.scene.disable_draggable_tools();
                if (!grid_configuration.get("visibility")){
                    global.tools.group_select("grid_color_update", "grid_toggle");
                    global.tools.tools["grid_move"].disable();
                    global.tools.tools["grid_resize"].disable();
                    return;
                }

                select_color();
            },
            close_handler: () => {
                log.debug("grid_settings_area: close_handler");
                if (global.scene.map.loaded) {
                    global.scene.enable_draggable_tools();
                }
                global.tools.tool_unselect("grid_move");
                global.tools.tool_unselect("grid_resize");
            },
            close_timer: true
        });

        global.tools.register({
            name: "grid_move",
            icon: "deplace f_mtac-icon-xlg",
            position: "#grid_settings",
            data: {move: false},
            enable: () => {
                log.debug("grid_move: enable");
                global.tools.tool_unselect("grid_resize");
                global.scene.interaction_disable("grid_resize");
                global.scene.interaction_enable("grid_move");
                if (global.scene.map.is_gis) {
                    // give the possibility to interact with the grid
                    $("#grid").attr("pointer-events", "all");
                }
                unselect_color();
            },
            disable: () => {
                log.debug("grid_move: disable");
                if (global.scene.map.is_gis) {
                    // give the possibility to interact with the grid
                    $("#grid").attr("pointer-events", "none");
                }
                global.scene.interaction_disable();
                select_color();
            }
        });
        global.tools.register({
            name: "grid_resize",
            icon: "grid_resize f_mtac-icon-xlg",
            position: "#grid_settings",
            data: {move: false},
            enable: () => {
                log.debug("grid_resize: enable");
                global.tools.tool_unselect("grid_move");
                global.scene.interaction_disable("grid_move");
                global.scene.interaction_enable("grid_resize");
                if (global.scene.map.is_gis) {
                    // give the possibility to interact with the grid
                    $("#grid").attr("pointer-events", "all");
                }
                unselect_color();
            },
            disable: () => {
                if (global.scene.map.is_gis) {
                    // give the possibility to interact with the grid
                    $("#grid").attr("pointer-events", "none");
                }
                global.scene.interaction_disable();
                select_color();
            }
        });

        global.tools.register_group({
            name: "grid_color_update",
            target: "$none",
            enable: (_, selected_tool) => {
                log.debug("grid_color_update: enable", {selected_tool});
                var grid_configuration = global.scene.map.grid.configuration;
                var {color, visibility} = selected_tool.data;
                if (color !== undefined && color !== grid_configuration.get("grid.color")) {
                    grid_configuration.set("grid.color", color);
                }
                if (visibility !== undefined && visibility !== grid_configuration.get("visibility")) {
                    grid_configuration.set("visibility", visibility);
                }
                if (visibility) {
                    global.tools.tools["grid_move"].enable();
                    global.tools.tools["grid_resize"].enable();
                }
                else {
                    global.tools.tools["grid_move"].disable();
                    global.tools.tools["grid_resize"].disable();
                }
                // Save the color in indexedDB
                global.scene.map.grid_save();
            },
            disable: () => {
                log.debug("grid_color_update: disable");
            }
        });
        
        for (let color of colors) {
            global.tools.register({
                group: "grid_color_update",
                name: `grid_${color.name}`,
                icon: "drop_black f_mtac-icon-xlg",
                position: "#grid_settings",
                classes: "btn-color-grid",
                data: {color: color.value, visibility: true},
                style: {color: color.value, "text-stroke": "1px #fff"}
            });
        }

        global.tools.register({
            group: "grid_color_update",
            name: "grid_toggle",
            icon: "drop_color_none f_mtac-icon-xlg",
            position: "#grid_settings",
            data : {visibility: false},
        });

        
        global.tools.register({
            name: "grid_reset",
            icon: "refresh f_mtac-icon-xlg",
            position: "#grid_settings",
            classes: "btn_grid btn-color-grid",
            handler: async () => {
                await global.scene.map.grid_reset();
                select_color();
            }
        });
    }
});

export default new GridSettingsArea();
